export default function HeroSection() {
  return (
    <section className="relative min-h-[700px] md:min-h-[800px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20editorial%20flat%20lay%20of%20premium%20fashion%20products%20including%20leather%20bags%20sneakers%20watches%20sunglasses%20and%20accessories%20scattered%20across%20warm%20terracotta%20toned%20surface%20soft%20morning%20sunlight%20streaming%20from%20window%20luxurious%20composition%20with%20rich%20textures%20and%20organic%20arrangement%20sophisticated%20aesthetic%20no%20text%20no%20logos%20no%20watermarks&width=1600&height=900&seq=vigor-v2-hero-bg&orientation=landscape"
          alt="Vigorbuy curated fashion products collage"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-background-50/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-6 md:px-8 pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="pt-10 md:pt-0">
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold leading-tight text-background-50">
              Vigorbuy<br />Spreadsheet
            </h1>
            <p className="font-heading text-2xl md:text-3xl text-background-200 mt-3 italic font-medium">
              The Ultimate Buying Resource
            </p>
            <p className="text-sm md:text-base text-background-200/80 mt-6 max-w-md leading-relaxed">
              Discover curated spreadsheets, trusted buying guides, QC resources, and product lists to help buyers shop smarter across 15+ categories.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 mt-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 bg-background-50 text-foreground-950 rounded-lg text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
              >
                Vigorbuy Sheet
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2.5 px-7 py-3.5 border border-background-300 text-background-100 rounded-lg text-sm font-medium hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-external-link-line text-base"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 mt-8">
              {['Updated Daily', 'Safe Buying Tips', 'QC Guides Included', 'Free Resources', 'Beginner Friendly'].map((badge) => (
                <span key={badge} className="flex items-center gap-1.5 text-xs text-background-200/90">
                  <i className="ri-check-line text-accent-400 text-sm"></i>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex items-center justify-center">
            <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-8 border border-background-100/20">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20clean%20spreadsheet%20dashboard%20interface%20displayed%20on%20tablet%20device%20resting%20on%20warm%20wooden%20desk%20surrounded%20by%20small%20fashion%20accessories%20soft%20window%20lighting%20editorial%20product%20showcase%20elegant%20minimal%20aesthetic%20no%20text%20no%20logos&width=600&height=700&seq=vigor-v2-hero-card&orientation=portrait"
                alt="Vigorbuy spreadsheet dashboard preview"
                className="w-full max-w-[400px] h-auto rounded-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}